import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

// import Login from "../../views/Login/Login";
// import Signup from "../../views/Signup/Signup";
// Auth Users
import Dashboard from "../../views/Dashboard/Dashboard";
import Locklist from "../../views/Locklist/Locklist";
import ShareHistory from "../../views/ShareHistory/index";
import AuditTrail from "../../views/AuditTrail/AuditTrail";
import AccountManagement from "../../views/AccountManagement/AccountManagement";
// import GroupManagement from "../../views/GroupManagement/GroupManagement";
import GroupManagementNew from "../../views/GroupManagementNew/GroupManagementNew";
import GrantAccess from "../../views/GrantAccess/GrantAccess";
import Plans from "../../views/Plans/Plans";
// import GroupShare from "../../views/GroupSharing/index";
import MemberManagement from "../../views/MemberManagement/MemberManagement";
import UserManagement from "../../views/UserManagement/UserManagement";
import RecipientManagement from "../../views/RecipientManagement/index";
import RetractableAccess from "../../views/RetractableAccess/retractable";
import MultiApprove from "../../views/MultiApproveManagement/MultiApprove";
import PageNotFound from "../../views/Errors/404Error";
import Setting from "../../views/SettingManagement/setting";
import Logs from "../../views/Logs/Logs";
// import SimpleMap from "../../views/AuditTrailMapview/MapView";
// import Plans from "../../views/Plans/Plans";
import Chatbot from "../../views/Chatbot/Chatbot";
import { customLog } from "../../variables/Variables";

// import Chatbot from "../../views/Chatbot/Chatbot";

export class AdminRoutes extends Component {
  componentWillMount() {
    customLog("Admin Route Being Run !");
  }
  render() {
    return (
      <div>
      <Switch>
        //! ACTIVE ROUTES //! LIVE ROUTES
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/" component={Plans} />
        <Route exact path="/locklist" component={Locklist} />
        <Route exact path="/userManagement" component={UserManagement} />
        <Route exact path="/GrantAccess" component={GrantAccess} />
        <Route exact path="/multiApprove" component={MultiApprove} />
        <Route exact path="/RetractableAccess" component={RetractableAccess} />
        <Route exact path="/audittrail" component={AuditTrail} />
        <Route exact path="/accountManagement" component={AccountManagement} />
        <Route exact path="/setting" component={Setting} />
        <Route exact path="/logs" component={Logs} />
        {/* <Route exact path="/chatbot" component={Chatbot} /> */}
        {/*  */}
        //! FOR TESTING (COMMENT OUT WHEN PUSHING TO LIVE)
        {/* <Route exact path="/groupManagement" component={GroupManagementNew} /> */}
        {/*  */}
        //! INACTIVE ROUTES
        {/* <Route
          exact
          path="/RecipientManagement"
          component={RecipientManagement}
        /> */}
        {/* <Route exact path="/memberManagement" component={MemberManagement} />  */}
        {/* <Route exact path="/groupManagement" component={GroupManagement} /> */}
        {/* <Route exact path="/ShareHistory" component={ShareHistory} /> */}
        {/* <Route exact path="/plans" component={Plans} /> */}
        {/* <Route exact path="/GroupSharing" component={GroupShare} />
        <Route exact path="/audittrailmapview" component={SimpleMap} />
        
        {/* <Route exact path="/test" component={Test} /> */}
        {/* <Route component={PageNotFound} /> */}
        {/*  */}
        //!DO NOT COMMENT OUT - MUST BE LAST
        <Route component={PageNotFound} />
      </Switch>
      {/* <Chatbot/> */}
      </div>
    );
  }
}

export default AdminRoutes;
